<template>
    <div class="e-between">
        <input type="text" v-model="from" @change="change"  />
        <span>{{separatorValue}}</span>
        <input type="text" v-model="to" @change="change"  />
        <button type="submit">
            <span class="mdi mdi-chevron-right"></span>
        </button>
    </div>
</template>

<script>
  import {EventBus} from '../../services/eventBus';

  export default {
    name: "between",
    props: {
      filterId: String,
      fromValue: String,
      toValue: String,
      separatorValue: String,
      measurementType: String,
      group: String,
      filtergroup: String,
      value: String,
      activeFilters: Array
    },
    data () {
      return {
        from: '',
        to: '',
        active: true
      }
    },
    mounted: function () {
      let vm = this;

      this.from = this.fromValue
      this.to = this.toValue

      EventBus.$on('filtersReset', function() {
        this.from = this.fromValue
        this.to = this.toValue
      }.bind(this))

      EventBus.$on('activeFiltersChanged', function() {
        this.setValuesFromActiveFilter()
      }.bind(this))

      this.setValuesFromActiveFilter();
    },
    methods: {
      setValuesFromActiveFilter() {
        let vm = this;
        this.activeFilters.forEach(function(element) {
          if (element.filterId === vm.filterId) {
            vm.from = element.min;
            vm.to = element.max;
          }
        });
      },
      change(){
        if (parseInt(this.from) > parseInt(this.to)) {
          let newfrom = this.to
          let newto = this.from
          this.from = newfrom
          this.to = newto
        }
        let filter = {filtergroup: this.filtergroup, group: this.group, value: this.value, min: this.from, max:this.to, filterId: this.filterId}

        // this.fValue = {name: this.measurementType, type: 'measurement', value: (this.from + ' - ' + this.to), min: parseInt(this.from), max: parseInt(this.to), active: this.active}
        EventBus.$emit('setFilter', filter)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/Between.vue